/**
 * Created by neo on 22.11.2023
 */
import { makeAutoObservable } from 'mobx';
import { Audited, createAuditedFields } from '../../Audited';
import { HttpBackend } from '../../../Services/Http/HttpBackend';

export type RouteChallengeTeamJoinRequest = Audited & {
  teamId: string;
  challengeId: string;
  gymId: string;
  customerId: string;
  athleteId: string;
  username: string;
  accept(): Promise<void>;
  decline(): Promise<void>;
};

export function createRouteChallengeTeamJoinRequest(json?: Partial<RouteChallengeTeamJoinRequest>): RouteChallengeTeamJoinRequest {
  const audited = createAuditedFields(json);
  return makeAutoObservable({
    ...audited,
    teamId: json?.teamId ?? '',
    challengeId: json?.challengeId ?? '',
    gymId: json?.gymId ?? '',
    customerId: json?.customerId ?? '',
    athleteId: json?.athleteId ?? '',
    username: json?.username ?? '',

    accept() {
      return HttpBackend.post(`/coach-program/engagement/route-challenges/teams/${this.teamId}/join-requests/${this.id}/accept`);
    },

    decline() {
      return HttpBackend.delete(`/coach-program/engagement/route-challenges/teams/${this.teamId}/join-requests/${this.id}`);
    },
  });
}
